document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.slideshow');

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.slideshow__slide');
    const nextBtn = slider.parentElement.querySelector('.slider-button--next');
    const prevBtn = slider.parentElement.querySelector('.slider-button--prev');

    if (slides.length <= 1) return;

    let current = 0;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? 'block' : 'none';
      });

      
    }

    function nextSlide() {
      current = (current + 1) % slides.length;
      showSlide(current);
    }

    function prevSlide() {
      current = (current - 1 + slides.length) % slides.length;
      showSlide(current);
    }

    // Affiche la première slide
    showSlide(current);

    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);

    // autoplay : utilise data-speed si défini
    const autoplaySpeed = slider.dataset.speed ? parseInt(slider.dataset.speed) * 1000 : 5000;
    setInterval(nextSlide, autoplaySpeed);

    
  });
});
